import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addStudentFormSchema = z.object({
  name: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.addStudent.name.required)
    .min(2, VALIDATION_MESSAGES.addStudent.name.min)
    .max(100, VALIDATION_MESSAGES.addStudent.name.max),

  studentId: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.addStudent.studentId.required),

  gender: z.string().nonempty(VALIDATION_MESSAGES.addStudent.gender.required),

  email: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.addStudent.email.required)
    .min(5, VALIDATION_MESSAGES.addStudent.email.min)
    .max(100, VALIDATION_MESSAGES.addStudent.email.max)
    .refine(
      (val) =>
        /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
          val
        ),
      { message: VALIDATION_MESSAGES.addStudent.email.invalid }
    ),

  classId: z.string().nonempty(VALIDATION_MESSAGES.addStudent.classId.required),

  sendCredentials: z.boolean().optional(),
});

export type TAddStudentForm = z.infer<typeof addStudentFormSchema>;
